module.exports = __webpack_public_path__ + "static/schmink4-e4334115346835889148e42c0273bdd4.jpg";